import { PortafolioService } from './../../services/portafolio.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portafolio',
  templateUrl: './portafolio.component.html',
  styleUrls: ['./portafolio.component.css']
})
export class PortafolioComponent implements OnInit {

  portafolio: any[];

  constructor(private portafolioService: PortafolioService) {
    this.portafolio = portafolioService.portafolio;
  }

  ngOnInit(): void {
  }

}
